import type { CSSProperties } from 'react'

interface CubeBadgeIconProps {
  className?: string
  size?: number
  style?: CSSProperties
  topClassName?: string
  leftClassName?: string
  rightClassName?: string
}

export const CubeBadgeIcon = ({
  className,
  size = 14,
  style,
  topClassName = '#6ac9ce',
  leftClassName = '#e5813e',
  rightClassName = '#f40009',
}: CubeBadgeIconProps) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      style={{ width: `${size}px`, height: `${size}px`, ...style }}
      aria-hidden="true"
      focusable="false">
      <path d="M12 3L4 7.5L12 12L20 7.5L12 3Z" className={topClassName} fill={topClassName} />
      <path d="M4 7.5V16.5L12 21V12L4 7.5Z" className={leftClassName} fill={leftClassName} />
      <path d="M20 7.5V16.5L12 21V12L20 7.5Z" className={rightClassName} fill={rightClassName} />
    </svg>
  )
}
